<div class="visionboard-item-add-remove-button">
  <ng-container *ngIf="compactMode; else largeButtonMode">
    <button
      *ngIf="showRemoveButton"
      mat-icon-button
      class="visionboard-item-button button-disable-hover-action-style"
      (click)="onRemoveClick($event)"
      [matTooltip]="removeButtonTooltip"
    >
      <mat-icon svgIcon="close"></mat-icon>
    </button>

    <button
      mat-icon-button
      class="visionboard-item-button button-disable-hover-action-style"
      *ngIf="showAddButton"
      (click)="onAddClick($event)"
      [matTooltip]="addButtonTooltip"
    >
      <mat-icon svgIcon="add"></mat-icon>
    </button>
  </ng-container>
</div>

<ng-template #largeButtonMode>
  <div class="large-button-container">
    <button
      mat-flat-button
      [color]="buttonColor"
      *ngIf="showRemoveButton"
      (click)="onRemoveClick($event)"
      class="merri-common-button-bold"
    >
      {{ removeButtonLargeText }}
    </button>
    <button
      mat-flat-button
      *ngIf="showAddButton"
      [color]="buttonColor"
      (click)="onAddClick($event)"
      class="merri-common-button-bold"
    >
      {{ addButtonLargeText }}
    </button>
  </div>
</ng-template>
